'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isBrowserMainThread = undefined;

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _isElectron = require('./is-electron');

var _isElectron2 = _interopRequireDefault(_isElectron);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var isNode = (typeof process === 'undefined' ? 'undefined' : (0, _typeof3.default)(process)) === 'object' && String(process) === '[object process]' && !process.browser; // based on https://github.com/uber/luma.gl/blob/master/src/utils/is-browser.js
// This function is needed in initialization stages,
// make sure it can be imported in isolation
/* global process */

var isBrowser = !isNode || _isElectron2.default;

// document does not exist on worker thread
var isBrowserMainThread = exports.isBrowserMainThread = isBrowser && typeof document !== 'undefined';

exports.default = isBrowser;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlscy9pcy1icm93c2VyLmpzIl0sIm5hbWVzIjpbImlzTm9kZSIsInByb2Nlc3MiLCJTdHJpbmciLCJicm93c2VyIiwiaXNCcm93c2VyIiwiaXNCcm93c2VyTWFpblRocmVhZCIsImRvY3VtZW50Il0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7OztBQUtBOzs7Ozs7QUFFQSxJQUFNQSxTQUNKLFFBQU9DLE9BQVAsdURBQU9BLE9BQVAsT0FBbUIsUUFBbkIsSUFDQUMsT0FBT0QsT0FBUCxNQUFvQixrQkFEcEIsSUFFQSxDQUFDQSxRQUFRRSxPQUhYLEMsQ0FQQTtBQUNBO0FBQ0E7QUFDQTs7QUFTQSxJQUFNQyxZQUFZLENBQUNKLE1BQUQsd0JBQWxCOztBQUVBO0FBQ08sSUFBTUssb0RBQXNCRCxhQUFhLE9BQU9FLFFBQVAsS0FBb0IsV0FBN0Q7O2tCQUVRRixTIiwiZmlsZSI6ImlzLWJyb3dzZXIuanMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBiYXNlZCBvbiBodHRwczovL2dpdGh1Yi5jb20vdWJlci9sdW1hLmdsL2Jsb2IvbWFzdGVyL3NyYy91dGlscy9pcy1icm93c2VyLmpzXG4vLyBUaGlzIGZ1bmN0aW9uIGlzIG5lZWRlZCBpbiBpbml0aWFsaXphdGlvbiBzdGFnZXMsXG4vLyBtYWtlIHN1cmUgaXQgY2FuIGJlIGltcG9ydGVkIGluIGlzb2xhdGlvblxuLyogZ2xvYmFsIHByb2Nlc3MgKi9cblxuaW1wb3J0IGlzRWxlY3Ryb24gZnJvbSAnLi9pcy1lbGVjdHJvbic7XG5cbmNvbnN0IGlzTm9kZSA9XG4gIHR5cGVvZiBwcm9jZXNzID09PSAnb2JqZWN0JyAmJlxuICBTdHJpbmcocHJvY2VzcykgPT09ICdbb2JqZWN0IHByb2Nlc3NdJyAmJlxuICAhcHJvY2Vzcy5icm93c2VyO1xuXG5jb25zdCBpc0Jyb3dzZXIgPSAhaXNOb2RlIHx8IGlzRWxlY3Ryb247XG5cbi8vIGRvY3VtZW50IGRvZXMgbm90IGV4aXN0IG9uIHdvcmtlciB0aHJlYWRcbmV4cG9ydCBjb25zdCBpc0Jyb3dzZXJNYWluVGhyZWFkID0gaXNCcm93c2VyICYmIHR5cGVvZiBkb2N1bWVudCAhPT0gJ3VuZGVmaW5lZCc7XG5cbmV4cG9ydCBkZWZhdWx0IGlzQnJvd3NlcjtcbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ./~/mjolnir.js/dist/utils/is-browser.js
// module id = 478
// module chunks = 35783957827783